<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div
      class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold"
      v-html="title"
    />
    <div class="col-12 col-md-8 col-xl-9">
      <button
        type="button"
        v-for="(item, index) in items"
        :key="index"
        :class="[
          'btn btn-sm btn-outline-filter',
          filterUiState('heatTransferCoefficient', item.value),
        ]"
        v-on:click="selectValue(item.value)"
      >
        {{ item.title }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { trackCallstack } from "../../../helper/tracker";

export default {
  name: "StoCscFilterSectionHeatTransferCoefficient",
  props: {
    addContainerClasses: String,
  },
  data: function () {
    return {
      title: "U-Wert [W/(m<sup>2</sup>K)]",
      items: [
        { title: "≤ 0,16", value: 0.16 },
        { title: "≤ 0,17", value: 0.17 },
        { title: "≤ 0,18", value: 0.18 },
        { title: "≤ 0,19", value: 0.19 },
        { title: "≤ 0,20", value: 0.20 },
        { title: "≤ 0,25", value: 0.25 },
        { title: "≤ 0,26", value: 0.26 },
        { title: "≤ 0,27", value: 0.27 },
        { title: "≤ 0,28", value: 0.28 },
        { title: "≤ 0,29", value: 0.29 },
        { title: "≤ 0,31", value: 0.31 },
        { title: "≤ 0,41", value: 0.41 },
        { title: "≤ 0,42", value: 0.42 },
        { title: "≤ 0,44", value: 0.44 },
        { title: "≤ 0,45", value: 0.45 },
        { title: "≤ 0,47", value: 0.47 },
        { title: "≤ 0,48", value: 0.48 },
        { title: "≤ 0,49", value: 0.49 },
        { title: "≤ 0,50", value: 0.50 },
        { title: "≤ 0,52", value: 0.52 },
        { title: "≤ 0,55", value: 0.55 },
        { title: "≤ 0,56", value: 0.56 },
      ],
    };
  },
  computed: {
    ...mapGetters({
      filterUiState: "filter/uiState",
      filterState: "filter/state",
    }),
  },
  methods: {
    selectValue: function (value) {
      let title = "";
      const result = this.items.filter((item) => item.value === value);
      if (result.length > 0) title = result[0].title;

      const uiState = this.filterUiState("heatTransferCoefficient", value);

      this.$gtm.trackEvent({
        event: "filter",
        category:
          this.title.split("<sup>").join("").split("</sup>").join("") +
          " " +
          title,
        action:
          uiState === "pending"
            ? "hinzufügen"
            : uiState === "active"
            ? "reaktivieren"
            : "aktivieren",
        label: title,
        value: value,
      });

      this.$store
        .dispatch("filter/setValue", {
          name: "heatTransferCoefficient",
          title: this.title + " " + title,
          value: value,
        })
        .then(() => trackCallstack(this.$gtm, this.filterState._callstack));
    },
  },
};
</script>
